import { NgModule } from '@angular/core';

import { ImageModule } from 'components/image/image.module';
import { TermsOfUsePdfModule } from 'components/terms-of-use-pdf/terms-of-use-pdf.module';
import { ContactLanguageComponent } from './';

import { SharedModule } from 'shared/shared.module';
import { DropdownModule } from 'shared/components/dropdown/dropdown.module';
import { ModalModule } from 'shared/components/modal/modal.module';

const components = [ContactLanguageComponent];

const modules = [DropdownModule, ModalModule, ImageModule, TermsOfUsePdfModule];

@NgModule({
    imports: [SharedModule, DropdownModule],
    declarations: components,
    exports: [...modules, ...components]
})
export class ComponentsModule {}
